module.exports = (__webpack_public_path__ || '') + "static/images/photo-4-0e7c1d09f0a9d0201289cbf0180bd585.jpg";